import { RequestStatusId, RequestStatusType } from '../store/state/requestStatusState';
import { useSelector } from 'react-redux';
import { AppState } from '../store/state/appState';
import { isRequestPending } from '../store/selectors/requestStatusSelectors';

export default function useIsRequestPending(type: RequestStatusType, id: RequestStatusId): boolean {
	const isPending = useSelector<AppState, boolean>(s => isRequestPending(s, type, id));
	return isPending;
}